export default "__VITE_ASSET__DVrNe0Wy__"